import SvgIcon from "@mui/material/SvgIcon";
import type React from "react";

export default function NumberIcon(): React.ReactNode {
  return (
    <SvgIcon viewBox="0 0 312 312">
      <path
        d="
M261.77 131l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C284.34 86 280.5 82 273 82H216a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88
z
M16 210h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V90a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 114h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8
z
m96 0H180a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H141.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C151 138.19 100 147.31 100 194.59v4C100 206 105.08 210 112.09 210
z
"
      />
    </SvgIcon>
  );
}
